import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { MortgageTag } from '@core/util/tags';
import { MatterDocumentType, MatterFile } from '@models/matter-file';
import { MatterMortgage } from '@models/mortgage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import { NavigationService } from '@services/nav/nav.service';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterUploadedFilesSelectors } from '@state/matter/uploaded-files/matter-uploaded-files.selectors';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import {
	UploadDocumentModalComponent,
	UploadModalDocumentData,
} from 'src/app/private/sale/documents/uploaded/modal/modal.component';
import { TestHooks } from './uploaded-documents.hooks';

@Component({
	selector: 'app-mortgage-uploaded-documents',
	templateUrl: './uploaded-documents.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MortgageUploadedDocumentsComponent implements OnInit, OnChanges {
	testHooks = TestHooks;
	@Input() title = 'Uploaded Documents';
	@Input('data-intercom-target') dataIntercomTarget: string;
	@Input() systemTags: string[] = [];
	@Input() mortgage: MatterMortgage;

	public ICON = ICON;
	public uploadedDocs$: Observable<MatterFile[]>;

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private matDialog: MatDialog,
		private storage: AngularFireStorage,
		private store: Store,
		private navService: NavigationService,
	) {}

	public ngOnInit(): void {
		this.updateUploadedDocs();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes['mortgage'] && this.mortgage) {
			this.updateUploadedDocs();
		}
	}

	private updateUploadedDocs(): void {
		if (!this.mortgage?.id) {
			return;
		}
		this.uploadedDocs$ = this.store
			.select(MatterUploadedFilesSelectors.getMortgageDocuments)
			.pipe(map((filterFn) => filterFn(this.mortgage.id)));
	}

	public upload(): void {
		const systemTags = [MortgageTag(this.mortgage.id), ...this.systemTags];

		const data: UploadModalDocumentData = {
			matterId: this.matterId,
			defaultFileType: MatterDocumentType.MORTGAGE,
			systemTags,
			lockFileType: true,
			contextId: this.mortgage.id,
		};
		this.matDialog.open(UploadDocumentModalComponent, {
			data,
			width: '80vw',
			maxWidth: '800px',
		});
	}

	public openPDF(file) {
		const ref = this.storage.ref(file.url);
		ref
			.getDownloadURL()
			.pipe(take(1))
			.subscribe((url) => {
				this.navService.goToRemoteUrl(url, true);
			});
	}
}
